// Photo utility functions

export const getImageSize = (
  file: File | string,
): Promise<{ width: number; height: number }> => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      resolve({ width: img.naturalWidth, height: img.naturalHeight });
    };
    img.onerror = reject;
    img.src = typeof file === "string" ? file : URL.createObjectURL(file);
  });
};

export const createThumbnail = (
  file: File | string,
  maxSize: number = 200,
): Promise<string> => {
  return new Promise((resolve, reject) => {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const img = new Image();

    img.onload = () => {
      const { width, height } = img;
      const ratio = Math.min(maxSize / width, maxSize / height);

      canvas.width = width * ratio;
      canvas.height = height * ratio;

      if (ctx) {
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        resolve(canvas.toDataURL("image/jpeg", 0.8));
      } else {
        reject(new Error("Could not get canvas context"));
      }
    };

    img.onerror = reject;
    img.src = typeof file === "string" ? file : URL.createObjectURL(file);
  });
};
